import store from '@/stores';

export function shouldChangePassword(to, from, next) {
  const isChangePassword = to.name === 'change-password';
  const { shouldChangePassword: validation } = store.state.user;

  if (validation && !isChangePassword) {
    next({ name: 'change-password' });
  } else {
    next();
  }
}

export default {
  shouldChangePassword,
};
